export const isRunningAsPWA = () => {
  console.log(
    window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
  );
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};
